module.exports = __webpack_public_path__ + "static/media/17UN-Women1.270c6f96.jpg";